import { Injectable } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  ICreateMojaFirmaCommand,
  IPodaciKorisnikaDto,
  TipPravnogLica,
} from '@kodit/core/data-api';
import {
  MobilniTelefonFormService,
  PravnoLiceFormService,
} from '@kodit/core/form-definitions';
import {
  FormBuilderTypeSafe,
  FormGroupTypeSafe,
} from 'angular-typesafe-reactive-forms-helper';
import { BehaviorSubject } from 'rxjs';
import { OdabirPaketaService } from '../../../../shared-subforms/src/lib/registracija/odabir-paketa.service';

@Injectable({ providedIn: 'root' })
export class RegisterService {
  form: FormGroupTypeSafe<ICreateMojaFirmaCommand>;
  isInitialized: boolean;

  constructor(
    private _fb: FormBuilderTypeSafe,
    private _pravnoLiceFS: PravnoLiceFormService,
    private _mobilniFS: MobilniTelefonFormService,
    private _odabirPaketaService: OdabirPaketaService
  ) {}

  get getForm(): FormGroupTypeSafe<ICreateMojaFirmaCommand> {
    if (!this.isInitialized) {
      this.init();
      this.isInitialized = true;
    }
    return this.form;
  }

  resetForm() {
    this.init();
  }

  showLoader$ = new BehaviorSubject<boolean>(false);

  get getShowLoader() {
    return this.showLoader$.asObservable();
  }

  set setShowLoader(value: boolean) {
    this.showLoader$.next(value);
  }

  private init() {
    this.form = this._fb.group<ICreateMojaFirmaCommand>({
      pravnoLiceDto: this._pravnoLiceFS.GetPravnoLiceFormGroup({
        tipPravnogLica: TipPravnogLica.DOMACE,
      }),
      podaciKorisnikaDto: this.getPodatkeKorisnikaFormGroup(),
      confirmationCode: new FormControl(null, {
        validators: [Validators.required],
      }),
      odabirPaketaDto: this._odabirPaketaService.getForm(),
      isTrial: new FormControl(false),
    });
  }

  private _passwordMatchValidator: ValidatorFn = (
    group: FormGroup
  ): ValidationErrors | null => {
    const sifra = group.get('sifra');
    const sifraRepeat = group.get('sifraRepeat');

    return sifra && sifraRepeat && sifra.value !== sifraRepeat.value
      ? { passwordMatchValidator: true }
      : null;
  };

  private getPodatkeKorisnikaFormGroup(): FormGroupTypeSafe<IPodaciKorisnikaDto> {
    return this._fb.group<IPodaciKorisnikaDto>(
      {
        ime: new FormControl(null, {
          validators: [Validators.required, Validators.maxLength(100)],
        }),
        mobilniDto: this._mobilniFS.GetMobilniFormGroup(null, true),
        prezime: new FormControl(null, {
          validators: [Validators.required, Validators.maxLength(100)],
        }),
        email: new FormControl(null, {
          validators: [
            Validators.required,
            Validators.email,
            Validators.maxLength(50),
          ],
        }),
        sifra: new FormControl(null, {
          validators: [
            Validators.required,
            Validators.minLength(9),
            Validators.maxLength(50),
          ],
        }),
        sifraRepeat: new FormControl(null, {
          validators: [Validators.required, Validators.maxLength(50)],
        }),
      },
      { validators: this._passwordMatchValidator }
    );
  }
}
